import React, { useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';

const GoogleSignIn = ({ onSuccess, onError }) => {
  const { login } = useAuth();

  const handleCredentialResponse = useCallback(async (response) => {
    try {
      const result = await login(response.credential);
      if (result.success) {
        onSuccess && onSuccess();
      } else {
        onError && onError(result.error);
      }
    } catch (error) {
      onError && onError('Authentication failed');
    }
  }, [login, onSuccess, onError]);

  useEffect(() => {
    // Load Google Sign-In script
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    script.onload = () => {
      if (window.google) {
        window.google.accounts.id.initialize({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          callback: handleCredentialResponse,
        });

        window.google.accounts.id.renderButton(
          document.getElementById('google-signin-button'),
          {
            theme: 'outline',
            size: 'large',
            width: '280',
            text: 'signin_with',
          }
        );
      }
    };

    return () => {
      document.head.removeChild(script);
    };
  }, [handleCredentialResponse]);

  return (
    <div className="google-signin-container">
      <div id="google-signin-button" className="google-signin-button-wrapper"></div>
      
    </div>
  );
};

export default GoogleSignIn;
